/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Invoice_Buyer_HintInputs */

const vi_order_form_invoice_buyer_hint = /** @type {(inputs: Order_Form_Invoice_Buyer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ chọn khi khách cần hóa đơn. Khi giao xong, hệ thống tự tạo hóa đơn và gửi MISA để kế toán kiểm tra, ký phát hành.`)
};

/**

* @param {Order_Form_Invoice_Buyer_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_invoice_buyer_hint = /** @type {((inputs?: Order_Form_Invoice_Buyer_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Invoice_Buyer_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_invoice_buyer_hint(inputs)
});